videojs.addLanguage('nn', {
  "Audio Player": "Lydspelar",
  "Video Player": "Videospelar",
  "Play": "Spel",
  "Pause": "Pause",
  "Replay": "Spel om att",
  "Current Time": "Aktuell tid",
  "Duration": "Varigheit",
  "Remaining Time": "Tid attende",
  "Stream Type": "Type straum",
  "LIVE": "DIREKTE",
  "Seek to live, currently behind live": "Hopp til live, spelar tidlegare i sendinga no",
  "Seek to live, currently playing live": "Hopp til live, speler live no",
  "Loaded": "Lasta inn",
  "Progress": "Framdrift",
  "Progress Bar": "Framdriftsvisar",
  "progress bar timing: currentTime={1} duration={2}": "{1} av {2}",
  "Fullscreen": "Fullskjerm",
  "Non-Fullscreen": "Stenga fullskjerm",
  "Mute": "Lyd av",
  "Unmute": "Lyd på",
  "Playback Rate": "Avspelingshastigheit",
  "Subtitles": "Teksting på",
  "subtitles off": "Teksting av",
  "Captions": "Teksting for høyrselshemma på",
  "captions off": "Teksting for høyrselshemma av",
  "Chapters": "Kapitel",
  "Descriptions": "Beskrivingar",
  "descriptions off": "beskrivingar av",
  "Audio Track": "Lydspor",
  "Volume Level": "Volumnivå",
  "You aborted the media playback": "Du avbraut avspelinga.",
  "A network error caused the media download to fail part-way.": "Ein nettverksfeil avbraut nedlasting av videoen.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videoen kunne ikkje lastas ned, på grunn av ein nettverksfeil eller serverfeil, eller av di formatet ikkje er stoda.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videoavspelinga blei broten på grunn av øydelagde data eller av di videoen ville gjera noe som nettlesaren din ikkje stodar.",
  "No compatible source was found for this media.": "Fant ikke en kompatibel kilde for dette mediainnholdet.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Mediefila er kryptert og vi manglar nyklar for å dekryptere ho.",
  "Play Video": "Spel av video",
  "Close": "Lukk",
  "Close Modal Dialog": "Lukk dialogvindauge",
  "Modal Window": "Dialogvindauge",
  "This is a modal window": "Dette er eit dialogvindauge",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Vindauget kan lukkast ved å trykke på Escape-tasten eller lukkeknappen.",
  ", opens captions settings dialog": ", opnar innstillingar for teksting for høyrselshemma",
  ", opens subtitles settings dialog": ", opnar innstillingar for teksting",
  ", opens descriptions settings dialog": ", opnar innstillingar for beskrivingar",
  ", selected": ", vald",
  "captions settings": "innstillingar for teksting",
  "subtitles settings": "innstillingar for teksting",
  "descriptions settings": "innstillingar for skildringar",
  "Text": "Tekst",
  "White": "Kvit",
  "Black": "Svart",
  "Red": "Raud",
  "Green": "Grøn",
  "Blue": "Blå",
  "Yellow": "Gul",
  "Magenta": "Magenta",
  "Cyan": "Turkis",
  "Background": "Bakgrunn",
  "Window": "Vindauge",
  "Transparent": "Gjennomsiktig",
  "Semi-Transparent": "Delvis gjennomsiktig",
  "Opaque": "Ugjennomsiktig",
  "Font Size": "Tekststorleik",
  "Text Edge Style": "Tekstkant",
  "None": "Ingen",
  "Raised": "Utheva",
  "Depressed": "Nedtrykt",
  "Uniform": "Enkel",
  "Dropshadow": "Skugge",
  "Font Family": "Skrifttype",
  "Proportional Sans-Serif": "Proporsjonal skrift utan seriffar",
  "Monospace Sans-Serif": "Fastbreddeskrift utan seriffar",
  "Proportional Serif": "Proporsjonal skrift med seriffar",
  "Monospace Serif": "Fastbreddeskrift med seriffar",
  "Casual": "Uformell",
  "Script": "Skråskrift",
  "Small Caps": "Kapitéler",
  "Reset": "Tilbakestell",
  "restore all settings to the default values": "tilbakestell alle innstillingar til standardverdiane",
  "Done": "Ferdig",
  "Caption Settings Dialog": "Innstillingsvindauge for teksting for høyrselshemma",
  "Beginning of dialog window. Escape will cancel and close the window.": "Byrjing på dialogvindauge. Trykk Escape for å avbryte og lukke vindauget.",
  "End of dialog window.": "Avslutning på dialogvindauge.",
  "{1} is loading.": "{1} lastar."
});